"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var Summary = function () {
    var t = (0, react_i18next_1.useTranslation)("en").t;
    return react_1["default"].createElement("div", { className: "Summary" }, t('summary'));
};
exports["default"] = Summary;
